<template>
  <ClinicFeatures />
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import { onlyRuPage } from '~/core/i18n'
import ClinicFeatures from '~/features/Home/components/FeaturesSection/ClinicFeatures/ClinicFeatures.vue'

definePageMeta({
  middleware: onlyRuPage,
})

useHead({
  link: generatePageMetaLinks({
    noAlternates: true,
  }),
})
</script>
